import { useTranslation } from 'react-i18next'
import { Badge } from '../ui/badge'

interface OrganizationStatusBadgeProps {
    status: 'active' | 'suspended' | 'deleted' | 'template' | string | undefined
}

// Visual mapping is intentionally small — the five states map to four badge
// variants because shadcn's default `secondary` covers both `template` and
// anything unrecognised.
const VARIANT_BY_STATUS: Record<string, 'default' | 'destructive' | 'outline' | 'secondary'> = {
    active: 'default',
    suspended: 'outline',
    deleted: 'destructive',
    template: 'secondary',
}

export function OrganizationStatusBadge({ status }: OrganizationStatusBadgeProps) {
    const { t } = useTranslation('admin')
    const key = status && VARIANT_BY_STATUS[status] ? status : 'active'
    const variant = VARIANT_BY_STATUS[key] ?? 'secondary'
    return (
        <Badge variant={variant} data-testid={`org-status-${key}`}>
            {t(`organizations.status.${key}`)}
        </Badge>
    )
}
